/**
 * 会議シーン種別
 */
export var SceneTypes;

(function (SceneTypes) {
  /**
   * ルーム
   */
  SceneTypes[SceneTypes["Room"] = 0] = "Room";
  /**
   * 360度画像
   */

  SceneTypes[SceneTypes["_360DegreeImage"] = 1] = "_360DegreeImage";
})(SceneTypes || (SceneTypes = {}));